import { Component, OnInit, Compiler } from '@angular/core';
import { Chart } from 'chart.js';
import { CommonService } from '../service/commons-service';
import { first, retry } from 'rxjs/operators';
import { Common } from '../util/common';
import { AppConfig } from '../util';
import { Router } from '@angular/router';


@Component({
    selector: 'app-rating-history',
    templateUrl: './rating-history.component.html',
    styleUrls: ['./rating-history.component.css']
})
export class RatingHistoryComponent implements OnInit {
     users: any = {};
     chart: any;
     userList: any[] = [];
     loading = false;
    loginUserName: any;
    userRoll: any;
     selectedCombinedId: any = 'Select User';
     activeTab = "beh";
     canvasContainerHeight: any;
     alreadyHalved: boolean = false;
    selectedUserId: any;
    selectedPositionId: any;
    funSkillRatingList: any = [];
    funSkillChartData: any  = [];
    behSkillChartData: any  = [];
    behSkillRatingList: any = [];
    isShowGraph: any = false;
    chartDataExist: any = true;
    dateRanges:any[] = [];
    lastSubmittedDate: any = [];
    convertedData:any[][] = [];
    constructor(
        private commonService: CommonService, 
        private router: Router, 
        private appConfig: AppConfig, 
        private common: Common, 
        private _compiler: Compiler
    ) { 
        this._compiler.clearCache();
        this.users = JSON.parse(localStorage.getItem('user'));
        if (!this.users || !this.users.userData) {
            this.commonService.logout();
            return;
        }
        if (this.users && this.users.userData) {
            if (this.users.userData.userFullName) {
                this.loginUserName = this.users.userData.userFullName;
            } else {
                this.loginUserName = this.users.userData.userName;
            }
            this.userRoll = this.users.userData.userRoll;
        }
    }

    ngOnInit() {
        this.getUsersList();
    }
    // Get All Users information
    private getUsersList() {
        this.loading = true;
        var userEmail = "";
        if (JSON.parse(localStorage.getItem('user')).userData.userRoll == 4)
            userEmail = JSON.parse(localStorage.getItem('user')).userData.userEmail;
        this.commonService.getUsersListByPost(JSON.parse(localStorage.getItem('user')).userData.towerId, userEmail).pipe(first()).subscribe(
            data => {
                this.loading = false;
                if (data && data.length > 0) {
                    this.userList = data;
                } else {
                    localStorage.setItem('errorMsg', "Users Not Found");
                    this.commonService.showerror();
                    localStorage.removeItem('errorMsg');
                }
            }, error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }
    private loadDashboard(skillType) {
        this.chartDataExist = true;
        this.funSkillRatingList = [];
        this.funSkillChartData = [];
        this.behSkillRatingList = [];
        this.behSkillChartData = [];
        this.getUserBehSkillRatingInfo();
    }
    /**
     * Get the functional skill rating history.
     */
    private getUserFunSkillRatingInfo() {
        this.activeTab = 'fun';
        this.funSkillRatingList = [];
        this.funSkillChartData = [];
        this.selectedUserId = this.selectedCombinedId.split("_")[0];
        this.selectedPositionId = this.selectedCombinedId.split("_")[1];
        let selectedUserTowerId = this.selectedCombinedId.split("_")[2];

        if (!this.selectedUserId || this.selectedUserId == "Select User") {
            localStorage.setItem('errorMsg', "Please select user first!");
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
            return;
        }
        this.loading = true;
        this.commonService.getUserFunSkillRatinghistory(Number(this.selectedUserId), Number(this.selectedPositionId)).subscribe(results => {
            if(results) {
                this.funSkillRatingList = results;
                var temDate: any = '';
                var filteredRatingHistory = [];
                let newArrIndex = 0;
                var compositeFunSum = 0;
                var funCount = 0;
                if (this.funSkillRatingList.length) {
                    // For show rgraph data.
                    this.convertData(true);
                    for (let i = 0; i < this.funSkillRatingList.length; i++) {
                        let date: any = new Date(this.funSkillRatingList[i].createDate);
                        date = date.getFullYear() + "-" + Number(date.getMonth() + 1) + "-" + date.getDate();
                        const createDate = date;
                        let obj = {
                            date: '',
                            score: 0
                        };
                        if (temDate == createDate || temDate == '') {
                            funCount++;
                        } else {
                            newArrIndex++;
                            obj = {
                                date: '',
                                score: 0
                            };
                            funCount = 1;
                        }
                        obj.date = createDate;
                        var thisSkillsPercentage = (this.funSkillRatingList[i].skillScore * 100) / this.funSkillRatingList[i].targetScore;
                        compositeFunSum += (thisSkillsPercentage > 100 ? 100 : thisSkillsPercentage);
                        obj.score = Math.floor(compositeFunSum / funCount);
                        filteredRatingHistory[newArrIndex] = obj;

                        temDate = createDate
                        if (i == this.funSkillRatingList.length - 1) {
                            console.log('filteredRatingHistory', filteredRatingHistory);
                            this.funSkillChartData = filteredRatingHistory;
                            this.isShowGraph = true;
                            this.generateSkillDevelopmentChart('fun');
                        }
                    }
                } else {
                    this.chartDataExist = false;
                    localStorage.setItem('errorMsg', "Rating history not found");
                    this.commonService.showerror();
                    localStorage.removeItem('errorMsg');
                    return;
                }
                
            }
            this.loading = false;
        }, error => {
            this.loading = false;
            console.log('Error', error);
        })

        
    }
    /**
     * Get the functional skill rating history.
     */
    private getUserBehSkillRatingInfo() {
        this.activeTab = 'beh';
        this.funSkillRatingList = [];
        this.funSkillChartData = [];
        this.selectedUserId = this.selectedCombinedId.split("_")[0];
        this.selectedPositionId = this.selectedCombinedId.split("_")[1];
        let selectedUserTowerId = this.selectedCombinedId.split("_")[2];

        if (!this.selectedUserId || this.selectedUserId == "Select User") {
            localStorage.setItem('errorMsg', "Please select user first!");
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
            return;
        }
        this.loading = true;
        this.commonService.getUserBehSkillRatinghistory(Number(this.selectedUserId), Number(this.selectedPositionId)).subscribe(results => {
            if (results) {
                this.behSkillRatingList = results;
                // For show rgraph data.
                this.convertData(false);
                var temDate: any = '';
                var filteredRatingHistory = [];
                let newArrIndex = 0;
                var compositeFunSum = 0;
                var funCount = 0;
                if (this.behSkillRatingList.length) {
                    for (let i = 0; i < this.behSkillRatingList.length; i++) {
                        let date: any = new Date(this.behSkillRatingList[i].createDate);
                        date = date.getFullYear() + "-" + Number(date.getMonth() + 1) + "-" + date.getDate();
                        const createDate = date;
                        let obj = {
                            date: '',
                            score: 0
                        };
                        if (temDate == createDate || temDate == '') {
                            funCount++;
                        } else {
                            newArrIndex++;
                            obj = {
                                date: '',
                                score: 0
                            };
                            funCount = 1;
                        }
                        obj.date = createDate;
                        var thisSkillsPercentage = (this.behSkillRatingList[i].skillScore * 100) / this.behSkillRatingList[i].targetScore;
                        compositeFunSum += (thisSkillsPercentage > 100 ? 100 : thisSkillsPercentage);
                        obj.score = Math.floor(compositeFunSum / funCount);
                        filteredRatingHistory[newArrIndex] = obj;

                        temDate = createDate
                        if (i == this.behSkillRatingList.length - 1) {
                            this.behSkillChartData = filteredRatingHistory;
                            this.isShowGraph = true;
                            this.generateSkillDevelopmentChart('beh');
                        }
                    }
                } else {
                    this.chartDataExist = false;
                    localStorage.setItem('errorMsg', "Rating history not found");
                    this.commonService.showerror();
                    localStorage.removeItem('errorMsg');
                    return;
                }
                
            }
            this.loading = false;
        }, error => {
            this.loading = false;
            console.log('Error', error);
        })

    }
    
    //generate total utilized chart
    private generateSkillDevelopmentChart(skillType) {
        var skillList;
        if (skillType === 'beh') {
            skillList = this.behSkillChartData;
        } else {
            skillList = this.funSkillChartData;
            this.alreadyHalved = true;
        }
        var ratings = [], labels = [], gaps = [], fullLabels = [];
        for (var i = 0; i < skillList.length; i++) {

            ratings.push(skillList[i].score);

            var skillName = skillList[i].date;
            labels.push(skillName);
            fullLabels.push(skillList[i].date);
           
            var gap = 100 - skillList[i].score;
            gaps.push(gap > 0 ? gap : 0);
        }

       

        if (this.chart) {
            this.chart.destroy();
        }


        this.canvasContainerHeight = (labels.length * 20) + 250 + "px";
      


        this.chart = new Chart('skill_development_chart', {
            type: 'horizontalBar',
            // height: 1000,
            // width: '100%',
            data: {
                labels: labels,
                textColor: '#000000',
                datasets: [{
                    label: 'Current',
                    data: ratings,
                    backgroundColor: '#28a745' // green
                },
                {
                    label: 'Gap',
                    data: gaps,
                    backgroundColor: '#d87107' // white
                }]
            },
            options: {
                maintainAspectRatio: false,
                responsive: true,

                legend: {
                    labels: {
                        // This more specific font property overrides the global property
                        fontColor: 'black'
                    }
                },

                tooltips: {
                    callbacks: {
                        title: function (tooltipItem, data) {
                            return fullLabels[tooltipItem[0].index];
                        },
                        label: function (tooltipItem, data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label || '';

                            if (label) {
                                label += ': ';
                            }
                          
                            label += tooltipItem.xLabel;
                            return label;
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            max: 100,
                            min: 0,
                            stepSize: 10
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        // barThickness: 40,
                        ticks: {
                            max: 100,
                            min: 0,
                            stepSize: 1
                        }
                    }]
                }
            }
        });
    }
    /**
     * List rating list daye wise.
     */
    private convertData(isFunctional) {
        var ratings1;
        console.log('this.funSkillRatingList', this.funSkillRatingList);
        if(isFunctional)
          ratings1 = this.funSkillRatingList;
        else
          ratings1 = this.behSkillRatingList;
    
        
        var ratings2 = [];
        // this.dateRanges = [1];
        this.dateRanges = [];
        this.lastSubmittedDate = [];
        let j = 0;
        let k = 1;
        console.log('List fullFunRatingList', ratings1);
        var tempStartDate ='';
        var tempEndDate = '';
        for (let dates = 0; dates < ratings1.length; dates++) {
            let newDateRange = this.formatDate(ratings1[dates].skillRatingFromDate) + " - "
                + this.formatDate(ratings1[dates].skillRatingToDate);
            if (this.dateRanges.indexOf(newDateRange) === -1) {
                this.dateRanges.push(newDateRange);
            }
        }
        for(let i = 0;i<ratings1.length;i++) {
          var curIndex = this.getIndexOf(ratings2, ratings1[i].skillName);
           
          if( curIndex === -1) {
            ratings2[j] = [];
            ratings2[j][0] = ratings1[i].skillName;
            ratings2[j][1] = ratings1[i].targetScore;
            curIndex = j;
            j++;
            for (let dateArray = 0; dateArray < this.dateRanges.length; dateArray++) {
                ratings2[curIndex].push(ratings1[i].skillScore);
              }
          } 
         // ratings2[curIndex].push(ratings1[i].skillScore);
        //   let newDateRange = this.formatDate(ratings1[i].skillRatingFromDate) + " - " 
        //                     + this.formatDate(ratings1[i].skillRatingToDate);
        //   console.log('this.dateRanges.indexOf(newDateRange)', this.dateRanges.indexOf(newDateRange));
        //   if(this.dateRanges.indexOf(newDateRange) === -1) {
        //       this.dateRanges.push(newDateRange);
        //   }
          console.log('this.dateRanges', this.dateRanges);
          let fSubmittedDate = ratings1[i].createDate; //this.formatDate();
          if (this.lastSubmittedDate.indexOf(fSubmittedDate) === -1) {
            this.lastSubmittedDate.push(fSubmittedDate);
          }
        }
        this.convertedData =  ratings2;
        console.log('this.convertedData', this.convertedData);
    }
    /**
     * Get index of array
     */
    private getIndexOf(arr, item) {
        for(let i=0;i<arr.length;i++) {
    
          if(arr[i] && arr[i][0] === item)
            return i;
        }
        return -1;
    }
    private formatDate(dateStr) {
        return new Date(dateStr).getDate() + "/" + (new Date(dateStr).getMonth() + 1) + "/" + new Date(dateStr).getFullYear();
      }
}
